function getRatingLabel(rating: number): string {
  if (rating >= 4.5) return "propertypage.reviews.ratinglabel.excellent";
  if (rating >= 4.0) return "propertypage.reviews.ratinglabel.verygood";
  if (rating >= 3.5) return "propertypage.reviews.ratinglabel.good";
  if (rating >= 3.0) return "propertypage.reviews.ratinglabel.average";
  return "propertypage.reviews.ratinglabel.belowaverage";
}

export default getRatingLabel;
